var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { sdsCustomElement } from '../utilities/custom-components';
import { iconSrc } from './icon-src';
import styles from './sds-icon.lit.scss';
/**
 * Component that renders icon matching given name.
 *
 * @tag sds-icon
 */
let SdsIcon = (() => {
    var _SdsIcon_color_accessor_storage, _SdsIcon_name_accessor_storage, _SdsIcon_size_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-icon')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _color_decorators;
    let _color_initializers = [];
    let _color_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    var SdsIcon = _classThis = class extends _classSuper {
        /**
         * Icon's color
         * @attr
         */
        get color() { return __classPrivateFieldGet(this, _SdsIcon_color_accessor_storage, "f"); }
        set color(value) { __classPrivateFieldSet(this, _SdsIcon_color_accessor_storage, value, "f"); }
        /**
         * Name of the icon to be rendered
         * @attr
         */
        get name() { return __classPrivateFieldGet(this, _SdsIcon_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsIcon_name_accessor_storage, value, "f"); }
        /**
         * Size of the icon
         * @attr
         */
        get size() { return __classPrivateFieldGet(this, _SdsIcon_size_accessor_storage, "f"); }
        set size(value) { __classPrivateFieldSet(this, _SdsIcon_size_accessor_storage, value, "f"); }
        render() {
            return html `
            <svg height="${this.size}" width="${this.size}" class="sds-icon">
                <use href="${iconSrc(this.name, this.size)}#${this.name}"></use>
            </svg>
        `;
        }
        constructor() {
            super(...arguments);
            _SdsIcon_color_accessor_storage.set(this, __runInitializers(this, _color_initializers, 'black'));
            _SdsIcon_name_accessor_storage.set(this, (__runInitializers(this, _color_extraInitializers), __runInitializers(this, _name_initializers, '')));
            _SdsIcon_size_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _size_initializers, 24)));
            __runInitializers(this, _size_extraInitializers);
        }
    };
    _SdsIcon_color_accessor_storage = new WeakMap();
    _SdsIcon_name_accessor_storage = new WeakMap();
    _SdsIcon_size_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsIcon");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _color_decorators = [property({ type: String })];
        _name_decorators = [property({ type: String, attribute: true })];
        _size_decorators = [property({ type: Number })];
        __esDecorate(_classThis, null, _color_decorators, { kind: "accessor", name: "color", static: false, private: false, access: { has: obj => "color" in obj, get: obj => obj.color, set: (obj, value) => { obj.color = value; } }, metadata: _metadata }, _color_initializers, _color_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsIcon = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsIcon = _classThis;
})();
export { SdsIcon };
